var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-table",
    {
      staticStyle: { width: "100%" },
      attrs: {
        data: _vm.registries,
        "row-key": "id",
        "tree-props": { children: "children", hasChildren: "hasChildren" },
      },
    },
    [
      _c("el-table-column", {
        attrs: { width: "90", prop: "id", label: "ID" },
      }),
      _vm._v(" "),
      _c("el-table-column", {
        attrs: { with: "100", prop: "device_id", label: "Device ID" },
      }),
      _vm._v(" "),
      _c("el-table-column", {
        attrs: { width: "100", prop: "state", label: "State" },
      }),
      _vm._v(" "),
      _c("el-table-column", {
        attrs: {
          width: "200",
          "show-overflow-tooltip": true,
          prop: "agent",
          label: "Agent",
        },
      }),
      _vm._v(" "),
      _c("el-table-column", {
        staticStyle: { "font-size": "small" },
        attrs: { prop: "created_at", label: "Date" },
      }),
      _vm._v(" "),
      _c("el-table-column", {
        attrs: {
          width: "300",
          "show-overflow-tooltip": true,
          prop: "checks",
          label: "Checks",
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }